import React, { useEffect, useRef, useState } from "react";

type ImageSet = { avif?: string; webp?: string; jpg: string };

interface Props {
  desktop: ImageSet;
  mobile?: ImageSet;
  breakpoint?: number; // px under which mobile chosen
  className?: string;
}

const PageBackground: React.FC<Props> = ({ desktop, mobile, breakpoint = 768, className }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(() => typeof window !== "undefined" ? window.innerWidth < breakpoint : false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            setShouldLoad(true);
            io.disconnect();
          }
        });
      },
      { rootMargin: "200px" }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  const imgs = isMobile && mobile ? mobile : desktop;

  return (
    <div ref={ref} className={`page-bg-container ${className || ""}`}>
      {shouldLoad && (
        <picture className="page-bg-picture" aria-hidden="true">
          {imgs.avif && <source type="image/avif" srcSet={imgs.avif} />}
          {imgs.webp && <source type="image/webp" srcSet={imgs.webp} />}
          <img className="page-bg-img" src={imgs.jpg} alt="" loading="lazy" />
        </picture>
      )}
    </div>
  );
};

export default PageBackground;